<template>
  <div class="ec" v-if="list.length">
    <div class="etl-title">
      <div class="title_dian">
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div class="txt">Video</div>
      <!-- <img src="@assets/img/new/icon-brand-l.png" />
      <div class="txt">精彩视频</div>
      <img src="@assets/img/new/icon-brand-r.png" /> -->
    </div>
    <div class="ec-content">
      <van-swipe class="my-swipe" indicator-color="'#ddd'" :autoplay="autoPlay"  @change="onChange" >
        <template v-for="(item,index) in list">
          <van-swipe-item :key="index">
            <div class="video_wrap">
              <div class="video_div" v-for="(mode,ind) in item" :key="ind">
                <!-- <video :src="mode.url" @play="onVideoPlay(mode.ind)" 
                :ref="'videoref'+mode.ind" 
                :poster="mode.cover" class="video_box" controls></video> -->
                <videoPlayer
                  :ref="'videoWai'+mode.ind"
                  :refName="'videoName'+mode.ind"
                  @onPlayerPlay="onVideoPlay(mode.ind)"
                  @onPlayerPause="onVideoPause(mode.ind)"
                  :url="mode.url"
                  :cover="mode.cover"
                ></videoPlayer>
                <p class="van-ellipsis">{{mode.titleEn}}</p>
              </div>
            </div>
          </van-swipe-item>
        </template>
      </van-swipe>
    </div>
  </div>
</template>

<script>
import { Swipe, SwipeItem } from "vant";
 import videoPlayer from "./videoPlayer";
import {mapGetters, mapActions} from "vuex";
import gql from "graphql-tag";
export default {
  name: "video-list",
  data() {
    return {
      pageSize: 4,
      list: [],
      len:0,
      autoPlay:'-',
      atIndex:0,
    };
  },
  components: {
    Swipe,
    SwipeItem,
    videoPlayer
  },
  created() {
    this.init()
  },
  computed:{
    ...mapGetters({
      exonId:"getExhibitionId",
      exhibitionConfig:'getExhibitionConfig'
    }),
    exhibitionId() {
      return this.$route.params.id||this.exonId;
    },
  
  },
  methods: {
    ...mapActions({
      graphqlPost: "en/graphqlPostByZXS",
      LinkAct:'linkTo/LinkAct',
    }),
    async init(){
      let query = `
        query($query:QueryInput!){
          exhibitionVideoQuery{
            query(query:$query){
              hasNextPage
              indexFrom
              pageIndex
              pageSize
              items{
                cover
                coverIndex
                createAt
                title
                titleEn
                url
                id
                showIndex
              }
            }
          }
        }
      `;
      let where = {
        Equal: {
          n: "exhibitionId",
          v: this.exhibitionId,
        },
      };
      let order = [
        {
          N: "showIndex",
          v: 0,
        },
        {
          N: "updateAt",
          v: 0,
        }
      ];
      let opt = {
        query: query,
        variables: {
          query: {
            page: 1,
            size: 10,
            where: JSON.stringify(where),
            order: JSON.stringify(order),
          },
        },
      };
      let data = await this.graphqlPost(opt);
      let res = JSON.parse(
        JSON.stringify(data.data.exhibitionVideoQuery.query)
      );
      this.len=res.items.length;
      let ExArr=[];
      res.items.forEach((e, i) => {
        const c = Math.floor(i / 2);
        if (!ExArr[c]) {
          ExArr[c] = [];
        }
        e.ind=i+1;
        ExArr[c].push(e);
      });
      this.list=ExArr;

      // console.log(this.list,'视频输出话')
      // this.videoList = res.items;
    },
    onChange(e){
      // console.log(e,'eee')
      for (let i = 1; i < this.len; i++) {
        let ref='videoWai'+i;
        this.$refs[ref][0].swiperChange()
      }
      
    },
    onVideoPlay(e){
      // console.log(e,'play')
      this.atIndex=e;
      for (let i = 1; i < this.len; i++) {
        if(i!=e){
          // console.log(i,e)
          let ref='videoWai'+i;
          this.$refs[ref][0].swiperChange()
        }
      }
      this.autoPlay='-'
      // arr.forEach((c,i)=>{
      //   console.log(i,e)
      //   if(i!=e){
      //     console.log('jinru');
      //     this.$refs.videoref.pause();
      //   }
      // })
    },
    onVideoPause(i){
      if(this.atIndex==i){
        this.autoPlay=3000
        // console.log(i,this.atIndex,'当前暂停');
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.ec {
  margin-bottom: 0;
  .etl-title {
    padding: 0.15rem 0.3rem;
    padding-top: 0;
    display: flex;
    align-items: center;
    font-size: 0.3rem;
    color: #333;
    .title_dian {
      display: flex;
      justify-content: space-between;
      width: 0.06rem;
      height: 0.24rem;
      flex-direction: column;
      margin-right: 0.1rem;
      position: relative;
      span {
        width: 0.06rem;
        height: 0.06rem;
        display: block;
        border-radius: 0.02rem;
        background-image: linear-gradient(90deg, #ff4b1b 0%, #fe781d 100%),
          linear-gradient(#108ee9, #108ee9);
        &:nth-child(1) {
          opacity: 0.5;
        }
        &:nth-child(2) {
          opacity: 0.75;
        }
      }
    }
    img {
      width: 13px;
    }
    .txt {
      // padding: 0 7px;
      font-size: 0.3rem;
      font-weight: bold;
    }
  }
  background: #fff;
  &-title {
    padding: 0.25rem 0;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 15px;
    color: #333;
    img {
      width: 13px;
    }
    .txt {
      padding: 0 7px;
      font-size: 0.3rem;
      font-weight: bold;
    }
  }
  &-content {
    padding: 0 0 0.3rem;
    background: #fff;
    width: 100%;
    .my-swipe{
      height: 2.7rem;
      width: 100%;
      .video_wrap{
        padding: 0 0.3rem;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: space-between;
        .video_div{
          width: 3.35rem;
          height: 100%;
          p{
            margin-top: 0.15rem;
            color: #333;
            font-size: .26rem;
          }
          .video_box{
            width: 100%;
            height: 1.88rem;
            border-radius: 0.05rem;
            overflow: hidden;
          }
        }
      }
    }
  }
}
.my-swipe {
  ::v-deep {
    
    .van-swipe__indicators {
      bottom: 1px;
    }
    .van-swipe__indicator {
      background-color: #ddd;
    }
    .van-swipe__indicator--active {
      background-color: #fe781d;
    }
    .van-swipe__track {
      padding-bottom: 0.1rem;
    }
  }
}
</style>